import React from 'react';
import { graphql } from 'gatsby';

import SEO from '../components/SEO/SEO';
import Layout from '../components/layout';
import HeaderComponent from '../components/Header';
import Hero from '../components/Hero/Hero';
import FooterComponent from '../components/Footer';

import PillarEmbed from '../components/PillarEmbed';
import SocialProof from '../components/SocialProof';

const PartnershipsDetail = ({ data: { datoCmsPartnership, socialProof } }) => {
  if (!datoCmsPartnership) return null;
  const {
    internalName,
    company: {
      name,
      description,
      metaTags,
      logo,
      email,
      phoneNumber,
      locations,
      products,
      solutions,
      industries,
    },
    post,
  } = datoCmsPartnership;

  return (
    <Layout theme="light">
      <HeaderComponent theme="Transparent - Dark" />
      <Hero
        component={{
          breadcrumbs: [
            {
              title: 'Home',
              pathname: '/',
            },
            {
              title: 'Partnerships',
              pathname: '/resources/partnerships/',
            },
            {
              title: name || internalName,
              pathname: '',
            },
          ],
          headingKicker: 'Partnerships',
          heading: name || internalName,
          subhead: description || metaTags?.description,
          showParallaxGrid: true,
          theme: 'Light',
          featuredContent: logo,
        }}
      />
      <PillarEmbed
        component={{
          companyDetails: {
            industries,
            locations,
            products,
            solutions,
          },
          contactInfo: {
            email,
            phoneNumber,
          },
          structuredText: post,
          showTableOfContents: true,
          showSubscriptionCard: false,
          showSlackCommunityCard: false,
        }}
        showParallaxGrid
      />
      <SocialProof component={socialProof} />
      <FooterComponent />
    </Layout>
  );
};

export default PartnershipsDetail;

export const Head = ({ data: { datoCmsPartnership }, location }) => {
  const { metaTags, indexable } = datoCmsPartnership;

  return (
    <SEO
      title={metaTags?.title}
      description={metaTags?.description}
      indexable={indexable}
      imgUrl={metaTags?.image?.url}
      pathname={location.pathname}
    />
  );
};

export const PartnershipsDetailQuery = graphql`
  query PartnershipsDetailQuery($id: String!, $language: String!) {
    datoCmsPartnership(id: { eq: $id }) {
      ...datoCmsPartnership
    }
    socialProof: datoCmsSocialProofComponent(
      id: { eq: "DatoCmsSocialProofComponent-XBrOiJ-dSYSs3C4ipc9ajg" }
    ) {
      ...datoCmsSocialProofComponent
    }
    locales: allLocale(
      filter: { ns: { in: ["index"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
